<template>
  <div class="search-cmp" @click.capture="jumpAIPage">
    <a-input-search placeholder="CoMi 一搜，答案即来" size="large" v-model="keyword"
      :allowClear="true">
      <div slot="enterButton" class="search-icon"></div>
    </a-input-search>
  </div>
</template>
<script>
import comiMixin from "@/mixins/comiMixin.js";
export default {
  name: "SearchGlobalvue",
  props: {
  },
  mixins: [comiMixin],
  data() {
    return {
      keyword: '',
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style scoped lang="scss">
.search-cmp{
  height: 56px;
  overflow: hidden;
  box-shadow: 0px 0px 14px 0px rgba(0,122,255,0.10);
  border-radius: 12px;
}
::v-deep {

  .ant-input-group-addon .ant-btn-lg,
  .ant-input {
    height: 56px;
    line-height: 56px;
    border: 1px solid rgba(0,122,255,0.20) !important;
    font-size: 20px;
    box-shadow: none;
    pointer-events: none;
  }
  
  .ant-input-group-addon .ant-btn-lg{
    border: 1px solid #007AFF !important;
  }

  .ant-input {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    padding-left: 1.5em;
    color: #000;
    transition: all .2s;
  }

  .ant-input-group-addon {
    width: 16%;
    overflow: hidden;
    background: transparent;

    .ant-btn-lg {
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      width: 100%;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      background: #007AFF;
    }
  }
  .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled){
    border-right-width: 2px!important;
  }
}
.search-cmp {
  cursor: pointer;  
}
.search-icon{
  background: center / 60% url("../../assets/imgs/comi.png") no-repeat;
  height: 100%;
}

@media screen and (max-width: 1440px) {

  .search-cmp ::v-deep {
    height: 44px;

    .ant-btn-lg,
    .ant-btn-primary {
      padding: 0 6px;
      font-size: 14px;
      height: 44px;
      line-height: 42px;
    }

    .ant-input-group-addon .ant-select {
      width: 100px !important;
    }

    .ant-input-lg {
      height: 44px;
      line-height: 44px;
      padding: 4px 20px;
      font-size: 14px;
    }
  }

  .search-icon{
    background-size: 60%;
  }
}


@media screen and (max-width: 1200px) {
  
  .search-icon{
    background-size: 80%;
  }
}

@media screen and (max-width: 824px) {

  .search-cmp ::v-deep {
    display: none;
    .ant-btn-lg,
    .ant-btn-primary {
      padding: 0 6px;
      font-size: 12px;
      height: 40px;
      line-height: 38px;
    }

    .ant-input-group-addon .ant-select {
      width: 100px !important;
    }

    .ant-input-lg {
      height: 40px;
      line-height: 40px;
      padding: 4px 10px;
      font-size: 14px;
    }
  }

  ::v-deep .ant-input-group-addon {
    width: 20%;
  }
    

  .search-cmp ::v-deep {
    .ant-input-group-addon {
      padding: 0px;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      // border: none;
    }
    .ant-input-group .ant-input {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      font-size: 12px;
    }
  }
}
</style>